import { Edit, ExpandMore, Update, Delete } from '@mui/icons-material';
// Components
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormLabel,
  IconButton,
  Typography
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { FC } from 'react';
import { ExternalLink } from '../../../../components/link/ExternalLink';
// Types
import { IDocumentTemplate } from '../../../../models';

interface IMobileContractTemplates {
  original: IDocumentTemplate;
  handleEdit?: (val: IDocumentTemplate) => void;
  handleDelete?: (val: IDocumentTemplate) => void;
}

export const MobileContractTemplates: FC<IMobileContractTemplates> = ({
  original,
  handleEdit,
  handleDelete
}) => {
  const classes = useStyles();
  const { vendorType, name, pandaDocTemplateId, subcontractorType, typeDisplayName } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{name}</Typography>
          <Box display="flex" alignItems="center">
            <ExternalLink
              target={'_blank'}
              to={`https://app.pandadoc.com/a/#/templates/${pandaDocTemplateId}`}
            >
              <IconButton className={classes.iconButton} color="primary" size="large">
                <Edit />
              </IconButton>
            </ExternalLink>
            <IconButton
              color="primary"
              className={classes.iconButton}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleEdit(original);
              }}
            >
              <Update />
            </IconButton>
            <IconButton
              color="error"
              className={classes.iconButton}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleDelete(original);
              }}
            >
              <Delete />
            </IconButton>
          </Box>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Name:
          </FormLabel>
          <Typography component="span" variant="body2">
            {name || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Document Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {typeDisplayName || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Vendor Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {vendorType || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Subcontractor Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {subcontractorType || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  iconButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
